/// <amd-module name="Wit/Common/QuerySaveDialog/Components/FolderDropdownGeneral" />
import * as React from "react";
import { ObservableValue } from "VSS/Core/Observable";
import { TimerManagement } from "VSS/Core/TimerManagement";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { Observer } from "VSSUI/Observer";
import { QueryHierarchyItem } from "Wit/Clients/Wit/Contracts/WorkItemTracking";
import { IQueryListService } from "Wit/Common/QueryListServices/IQueryListService";
import { IQuerySaveDialogProps } from "Wit/Common/QuerySaveDialog/Components/QuerySaveDialog.Props";
import * as Resources from "Wit/Common/QuerySaveDialog/Resources";
import { QuerySaveDialogMode } from "Wit/Common/QueryUtils/Models";
import { QueryItemDropdown } from "./QueryItemDropdown";

interface IFolderDropdownGeneralProps extends IQuerySaveDialogProps {
    onQueriesChanged: (queryId: string) => string;
    projectId?: string | undefined;
    disabled?: boolean| undefined;
}
const c_defaultDebounceWait = 200;

export class FolderDropdownGeneral extends VssComponent<IFolderDropdownGeneralProps> {
    private _debouncedQueryFolderValidation: (folderPath: string) => void;
    private _listService: IQueryListService;
    public QueryID: QueryHierarchyItem | undefined;
    public _path: ObservableValue<string> = new ObservableValue("");
    
    constructor(props: IFolderDropdownGeneralProps, context: IVssComponentContext) {
        super(props, context);

        if (this.props.queryItem) {
            this._path.value = this._getQueryParentPath() ?? "";
        }
        if (!this._path.value) {
            this._path.value = Resources.SharedQueries;
        }

        this._listService = this.context.pageContext.getService<IQueryListService>("IQueryListService");
    }

    componentDidUpdate(prevProps: Readonly<IFolderDropdownGeneralProps>, prevState: Readonly<{}>, snapshot?: {}): void {
        if (this.props.projectId !== prevProps.projectId) {
            this._setPath(Resources.SharedQueries);
        }
    }
    
    public render(): JSX.Element {
        return (
                <QueryItemDropdown
                    onSetFolder={path => {
                        if (path) {
                            this._setPath(path);
                        }
                    }}
                    selectedText={this._path}
                    projectId={this.props.projectId}
                    disabled={this.props.disabled}
                />
        );
    }

    private async _setPath(path: string) {
        const newPath = path || "";
        this._path.value = path;
        try {
            if (this.props.projectId) {
                this.QueryID = await this._listService.getQueryByPath(newPath,this.props.projectId);
            }
            let temp = this.QueryID;
            if (temp) this.props.onQueriesChanged(temp.id);
        } catch (error) {}
    }

    private _getQueryParentPath() {
        return this.props.mode === QuerySaveDialogMode.RenameQuery ||
            this.props.mode === QuerySaveDialogMode.RenameFolder ||
            this.props.mode === QuerySaveDialogMode.SaveAs
            ? this.props.queryItem?.path.slice(0, this.props.queryItem?.path.lastIndexOf("/"))
            : this.props.queryItem?.path;
    }
}
VssComponent.register("FolderDropdownGeneral", FolderDropdownGeneral);
